/**
 * BoardEdge — custom connection line with an optional label pill, rendered
 * via EdgeLabelRenderer so the label is a normal HTML element (not SVG
 * text) and can host a click-to-edit affordance.
 */

import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import { cx } from '@/components/site/primitives';

export default function BoardEdge({
  id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, markerEnd, data, selected,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
  });

  const muted = data?.muted;

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: selected ? 'var(--color-coral)' : 'var(--color-border)',
          strokeWidth: selected ? 2 : 1.5,
          opacity: muted ? 0.25 : 1,
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
          onClick={(e) => { e.stopPropagation(); data?.onEditLabel?.(); }}
          className={cx(
            'nodrag nopan cursor-pointer rounded-full border border-line bg-card px-2 py-0.5 text-[10px] font-semibold text-subtle shadow-soft transition-opacity hover:text-coral',
            muted && 'opacity-25'
          )}
        >
          {data?.label?.trim() ? data.label : '+ label'}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
